module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19sYIaK/tc-custom/9781439671177.jpg?1705026193502",
      "alt": "This image is the cover for the book Wicked New Hampshire, Wicked"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wicked New Hampshire, Wicked\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Behind New Hampshire's scenic landscape lies some very dark history, ranging from horrible hangings to scandalous socialites. The Fireman's Riot of 1869 resulted in most of Manchester burning to the ground. New England's largest rumrunning gang was finally prosecuted due to an overdue library book. Madame Sherri so scandalized the Chesterfield area at the turn of the century that she now has a state park named after her. Author Renee Mallett reveals the surprising and sometimes shocking history from the Seacoast to the Great North Woods.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Renee Mallett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Renee Mallett is the author of Haunted Colleges and Universities of Massachusetts and many other books exploring the history, legends and lore of New England. She has published numerous pieces of writing, ranging from short fiction to poetry, celebrity interviews to travel essays. She lives in southern New Hampshire with her family, where her fine art is showcased in galleries and private collections.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0